module.exports = __webpack_public_path__ + "static/media/content.33536c44.svg";